import styled from 'styled-components';

import { media } from '../../../../../helpers/breakpoints';

import { LabelProps, SpacingProps, FontSizeProps } from './Price.typed';

const Container = styled.div`
  display: flex;
  align-items: end;
`;

const PriceContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const PriceLabelWrapper = styled.div<{ flip?: boolean }>`
  position: relative;
  ${({ theme }) => theme.donedeal.fontSize.M14};

  ${media.medium} {
    order: ${({ flip }) => (flip ? '2' : '0')};
  }
`;

const PriceDrop = styled.span<FontSizeProps>`
  ${({ theme, smallFontSize }) => theme.donedeal.fontSize[smallFontSize]};
  color: ${({ theme }) => theme.donedeal.colors.RED};
  position: relative;

  ${media.medium} {
    ${({ theme, mediumFontSize }) => theme.donedeal.fontSize[mediumFontSize]};
  }

  &:after {
    position: absolute;
    content: '';
    left: 0;
    top: 50%;
    right: 0;
    border-top: 1px solid;
    border-color: inherit;
    transform: rotate(-12.2deg);
  }
`;

const Label = styled.p<LabelProps>`
  display: ${({ isGrid }) => (isGrid ? 'none' : 'inline-block')};
  ${({ theme }) => theme.donedeal.fontSize.M14};

  ${media.medium} {
    display: inline-block;
  }
`;

const Text = styled.p<FontSizeProps>`
  ${({ theme, smallFontSize }) => theme.donedeal.fontSize[smallFontSize]};
  font-weight: ${({ theme, regularWeight }) =>
    regularWeight
      ? theme.donedeal.fontWeight.regular
      : theme.donedeal.fontWeight.bold};
  color: ${({ theme }) => theme.donedeal.colors.GREY_DARKER};

  ${media.medium} {
    ${({ theme, mediumFontSize }) => theme.donedeal.fontSize[mediumFontSize]};
  }
`;

const NextToPriceContainer = styled.div<SpacingProps>`
  border-left: solid ${({ theme }) => theme.donedeal.colors.GREY_LIGHT} 1px;
  padding-left: ${({ theme, gapSmall }) => theme.donedeal.spacing[gapSmall]};
  margin-left: ${({ theme, gapSmall }) => theme.donedeal.spacing[gapSmall]};

  ${media.medium} {
    padding-left: ${({ theme, gapMedium }) =>
      theme.donedeal.spacing[gapMedium]};
    margin-left: ${({ theme, gapMedium }) => theme.donedeal.spacing[gapMedium]};
  }
`;

const PricePerMonthDisplay = styled.span`
  ${({ theme }) => theme.donedeal.fontSize.B12};
  font-weight: ${({ theme }) => theme.donedeal.fontWeight.regular};
`;

export {
  Container,
  NextToPriceContainer,
  PriceLabelWrapper,
  PriceDrop,
  Label,
  Text,
  PricePerMonthDisplay,
  PriceContainer,
};
